import axios from '../../../axiosInstance.ts'
import {Measure} from '@/features/measures/services/types.ts'

export const HttpGetMeasureDetailsResponse = Measure
export const httpGetMeasureDetails = (id?: string) => {
    return axios.get(`/v1/measures/${id}`, {
        params: {
            responseType: 'extended'
        }
    })
}

export const httpGetMeasureRawHtml = (id?: string) => {
    return axios.get(`/v1/measures/${id}/raw`)
}
